import React from 'react'
import { Box } from '@mui/material'
import { IngestionFromS3 } from './IngestionFromS3'
import { NewTreesTable } from '../../components/ingestion/NewTreesTable'
import { UserMessages } from './UserMessages'
import { GDRiveContentLocation } from './GDriveContentLocation'
import { Walkthrough } from './Walkthrough'

export function OSEIngest() {
  return (
    <Box>
      <Box>OpenSciEd</Box>
      <UserMessages />
      <IngestionFromS3 />
      <GDRiveContentLocation />
      <NewTreesTable />
      <Walkthrough />
    </Box>
  )
}
